export default {"src":"/_next/static/image/src/assets/footer/twitter.7de4c52a549aa22a65c8c23f110c23ae.svg","height":24,"width":24};